const signBathLines = [
    // Line 1
    "Stillness fills the steam—\nleave your worries at the door,\nthey'll wait, but you won’t.",
    // Line 2
    "Soap clings, then vanishes—\nlike the names we used to wear.\nWarm water remembers.",
    // Line 3
    "Shadows fog the tiles.\nEven silence needs to soak\nin something gentle.",
    // Line 4
    "Beneath lantern glow,\nWhispers of time in still air,\nGuests rest, dreams unfold.",
  ];

export default signBathLines;
